import { NgModule } from '@angular/core';
import { WhyPostexComponent } from './components/why-postex/why-postex.component';
import { OurPartnersComponent } from './components/our-partners/our-partners.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CommonModule } from '@angular/common';
import { UpfrontPaymentSliderComponent } from './components/upfront-payment-slider/upfront-payment-slider.component';
import { LogisticsFeaturesComponent } from './components/logistics-features/logistics-features.component';
import { AllPlateformsComponent } from './components/all-plateforms/all-plateforms.component';
import { WaitingForComponent } from './components/waiting-for/waiting-for.component';


const components = [
  WhyPostexComponent,
  OurPartnersComponent,
  UpfrontPaymentSliderComponent,
  LogisticsFeaturesComponent,
  AllPlateformsComponent,
  WaitingForComponent,


]


@NgModule({
  declarations: [
    ...components,
    
  ],
  imports: [
    CommonModule,
    SlickCarouselModule,

  ],
  exports: [
    ...components
  ]
})
export class SharedModule { }
